import SearchQuery from "../../search2/SearchQuery";

export default class WordHighlighter {

    public static getHighlightIndexes(words: string[], highlightQuery: SearchQuery): number[] {
        const highlightIndexes = [];

        for (const queryPart of highlightQuery.getParts()) {
            for (let wordIndex = 0; wordIndex < words.length - (queryPart.words.length - 1); wordIndex++) {
                let partMatches = true;
                const partMatchIndexes = [];

                for (let partWordIndex = 0; partWordIndex < queryPart.words.length; partWordIndex++) {
                    const word = this.prepareWord(words[wordIndex + partWordIndex]);
                    const partWord = this.prepareWord(queryPart.words[partWordIndex]);

                    partMatches = partMatches && word === partWord;
                    if (!partMatches) {
                        break;
                    }

                    partMatchIndexes.push(wordIndex + partWordIndex);
                }

                if (partMatches) {
                    for (const i of partMatchIndexes) {
                        if (highlightIndexes.indexOf(i) === -1) {
                            highlightIndexes.push(i);
                        }
                    }
                }
            }
        }

        return highlightIndexes;
    }

    public static highlightWords(words: string[], highlightIndexes: number[]): string[] {
        const validHighlightIndexes = highlightIndexes.filter(index => index >= 0 && index < words.length).sort();
        let needCloseTag = false;

        for (let i = 0; i < validHighlightIndexes.length; i++) {
            const highlightIndex = validHighlightIndexes[i];
            let word = words[highlightIndex];

            if (!needCloseTag) {
                word = '<span class="_Highlighted">' + word;
            }

            if ((i < validHighlightIndexes.length - 1) &&
                    (validHighlightIndexes[i + 1] === highlightIndex + 1)) {
                needCloseTag = true;
            } else {
                word += '</span>';
                needCloseTag = false;
            }

            words[highlightIndex] = word;
        }

        return words;
    }

    private static prepareWord(word: string): string {
        return word.replace(/[\W_]/g, '').toLowerCase();
    }
}
